/*
	1R Scripts Entry
*/

/*
	Kick off FE Routing
*/
import 'App/router';
console.log('ORW Index JS loaded');